import "./style.css";

export default class Modal {
  constructor(modal) {
    this.modal = modal;
    if (!this.modal) {
      return;
    }

    this.backdrop = this.modal.querySelector(".modal__backdrop");
    this.dialog = this.modal.querySelector(".modal__dialog");
    this.closeButton = this.dialog.querySelector(".modal__close");
    this.title = this.dialog.querySelector(".modal__title");

    this.openings = 0;
    this.isOpen = false;

    this.options = {
      title: this.title.textContent
    };
    this.mount();
  }

  // Methods to be defined on extendee classes
  async modalWillMount() {}
  async modalDidMount() {}
  async modalWillOpen() {}
  async modalDidOpen() {}
  async modalWillClose() {}
  async modalDidClose() {}
  async modalDidUpdate() {}
  async modalWillUnmount() {}

  async mount() {
    await this.modalWillMount();

    this.backdrop.addEventListener("click", this.close);
    this.closeButton.addEventListener("click", this.close);

    await this.modalDidMount();
  }

  async closeAllModals() {
    await Promise.all(
      Object.keys(window.App.modals).map(m => window.App.modals[m].close())
    );
  }
  lockBodyScroll = () => {
    document.body.classList.add("modal-scroll-lock");
  };
  unlockBodyScroll = () => {
    document.body.classList.remove("modal-scroll-lock");
  };

  // public methods
  update = options => {
    this.options = {
      ...this.options,
      ...options
    };

    if (this.title.innerText !== this.options.title) {
      this.title.innerText = this.options.title;
    }

    this.modalDidUpdate(options);
  };
  open = async () => {
    if (this.isOpen) {
      return;
    }

    await this.closeAllModals();

    await this.modalWillOpen();

    this.lockBodyScroll();
    this.modal.classList.add("modal--open");
    this.isOpen = true;

    await this.modalDidOpen();
  };
  close = async () => {
    if (!this.isOpen) {
      return;
    }

    await this.modalWillClose();

    this.modal.classList.remove("modal--open");
    this.isOpen = false;
    this.unlockBodyScroll();

    await this.modalDidClose();
  };
}
